"use strict";
const SymbolTree = require("symbol-tree");

exports.cloningSteps = Symbol("cloning steps");
exports.locationInfo = Symbol("location info");

// TODO: the many underscore-prefixed hooks should move here
// E.g. _attrModified (which maybe should be split into its per-spec variants)

/**
 * This SymbolTree is used to build the tree for all Node in a document
 */
exports.domSymbolTree = new SymbolTree("DOM SymbolTree");



//////////////////
// WEBPACK FOOTER
// ./~/jsdom/lib/jsdom/living/helpers/internal-constants.js
// module id = 69
// module chunks = 0